import React from 'react';
import {
  Button,
  Icon,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip,
  IconButton
} from '@material-ui/core/';
import { useTranslation } from 'react-i18next';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { colors } from '../../utils';
import FarmSettings from '../FarmSettings';

/** The farm settings screen behind a settings icon button. A feature, not a primitive: it lives here, not in elements. */
const FarmSettingsOptionsModal = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Tooltip arrow title={t('f-settings-opt')}>
        <IconButton size="medium" color="primary" onClick={() => setOpen(true)}>
          <Icon>{'settings'}</Icon>
        </IconButton>
      </Tooltip>

      <Dialog onClose={handleClose} aria-labelledby="farm-settings-modal" fullWidth maxWidth="sm" open={open}>
        <DialogTitle className={classes.dialogHeaderFooter}>{t('f-settings-farm')}</DialogTitle>

        <DialogContent className={classes.content}>
          <FarmSettings onUpdated={handleClose} />
        </DialogContent>

        <DialogActions className={classes.dialogHeaderFooter}>
          <Button onClick={handleClose} variant="outlined" color="primary">
            {t('m-global-close')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default FarmSettingsOptionsModal;

const useStyles = makeStyles(() =>
  createStyles({
    content: {
      padding: 4
    },
    dialogHeaderFooter: {
      background: colors.defaultGrey
    }
  })
);
